import {StringMatchingFilter} from '../libs/table-row-filter'

import {Action, DateRange} from '../../../commons/src/types'

import {Order, OrderStatusType} from '../order-types'

export type LoadOrdersAction = Action<'ORDER.LOAD_ORDERS', void>
export type LoadOrdersFailedAction = Action<'ORDER.LOAD_ORDERS_FAILED', void>
export type OrdersReceivedAction = Action<'ORDER.ORDERS_RECEIVED', Order[]>
export type UpdateOrderAction = Action<'ORDER.UPDATE_ORDER', Order>
export type UpdateStatusFilterAction = Action<
  'ORDER.UPDATE_STATUSFILTER',
  StringMatchingFilter<{
    status: OrderStatusType
  }>
>
export type UpdateCreationDateRangeAction = Action<'ORDER.UPDATE_CREATION_DATE_RANGE', DateRange>

export type OrdersAction =
  | LoadOrdersAction
  | LoadOrdersFailedAction
  | OrdersReceivedAction
  | UpdateOrderAction
  | UpdateStatusFilterAction
  | UpdateCreationDateRangeAction

export const loadOrders = (): LoadOrdersAction => ({
  type: 'ORDER.LOAD_ORDERS',
  payload: undefined,
})

export const loadOrdersFailed = (): LoadOrdersFailedAction => ({
  type: 'ORDER.LOAD_ORDERS_FAILED',
  payload: undefined,
})

export const ordersReceived = (orders: Order[]): OrdersReceivedAction => ({
  type: 'ORDER.ORDERS_RECEIVED',
  payload: orders,
})

export const updateOrder = (payload: Order): UpdateOrderAction => ({
  type: 'ORDER.UPDATE_ORDER',
  payload,
})

export const updateStatusFilter = (
  payload: StringMatchingFilter<{
    status: OrderStatusType
  }>
): UpdateStatusFilterAction => ({
  type: 'ORDER.UPDATE_STATUSFILTER',
  payload,
})

export const updateCreationDateRange = (payload: DateRange): UpdateCreationDateRangeAction => ({
  type: 'ORDER.UPDATE_CREATION_DATE_RANGE',
  payload,
})
